<template lang="html">
  <el-menu 
    :default-active="$route.path" 
    :router="true" 
    class="sidebar-menu" 
    mode="vertical" 
    :collapse="!isCollapse"
    unique-opened
  >
      <div class="sidebar-collapse-switch">
        <el-switch
          v-model="isCollapse"
          @change="collapse"
        >
        </el-switch>
      </div>

      <div v-for="child in getMenuList" :key="child.path">
        <el-menu-item
          v-if="child.type != 'sub'"
          :class="$route.path === child.path ? 'is-active' : ''"
          :index="child.path"
        >
          <div class="icon-container">
             <font-awesome-layers class="fa-lg">
                <font-awesome-icon :icon="child.icon" />
             </font-awesome-layers>
          </div>
          <span slot="title" class="route-name">{{ $t(`sidebar.${child.name}`) }}</span>
        </el-menu-item>

        <el-submenu :index="child.menuIndex || child.name" v-else>
          <template slot="title">
             <div class="icon-container">
                <font-awesome-layers class="fa-lg">
                  <font-awesome-icon :icon="child.icon" />
                </font-awesome-layers>
             </div>
            <span slot="title" class="route-name">{{ $t(`sidebar.${child.name}`) }}</span>
          </template>
          
          <el-menu-item
            v-for="listchild in child.menuList"
            :index="listchild.path"
            :class="$route.path === listchild.path ? 'is-active' : ''"
            :key="listchild.path"
          >
             <div class="icon-container">
                <font-awesome-layers class="fa-lg">
                  <font-awesome-icon :icon="listchild.icon" />
                </font-awesome-layers>
             </div>
            <span slot="title" class="route-name">{{ $t(`sidebar.${listchild.name}`) }}</span>
          </el-menu-item>
        </el-submenu>
      </div>

      <el-menu-item
        v-if="!isAdmin && enableLayoutPin"
        index="/layout-settings"
        :class="$route.path === '/layout-settings' ? 'is-active' : ''"
      >
        <div class="icon-container">
          <font-awesome-layers class="fa-lg">
            <font-awesome-icon icon="image" />
          </font-awesome-layers>
        </div>
        <span slot="title" class="route-name">平面圖設定</span>
      </el-menu-item>

      <el-submenu v-if="showAdminMenu" index="admin-section">
        <template slot="title">
          <div class="icon-container">
             <font-awesome-layers class="fa-lg">
               <font-awesome-icon icon="user-cog" />
             </font-awesome-layers>
          </div>
          <span slot="title" class="route-name">Admin</span>
        </template>
        <el-menu-item-group v-for="group in filteredAdminMenuList" :key="group.label">
             <span slot="title" class="group-name">{{ group.label }}</span>
             <el-menu-item v-for="child in group.routes" :key="child.path" :index="child.path">
               <font-awesome-layers class="fa-lg">
                 <font-awesome-icon :icon="child.icon" />
               </font-awesome-layers>
               <span class="route-name">{{ child.name }}</span>
             </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
  </el-menu>
</template>

<script>
import { sidebar, clientVersion } from '@/constants/env';
import { isThsrProject } from '@/lib/base/project';
const kmrtRole   = clientVersion === 'test' || clientVersion === 'kmrt';
const importRole = clientVersion === 'test' || clientVersion === 'kmrt' || clientVersion === 'thsr-main';
const isThsrMain  = clientVersion === 'thsr-main';
export default {
  //props: {
  //  isCollapse: {dmin
  
  //    type: boolean,
  //    require: true,
  //  },
  //},
  data() {
    return {
      isCollapse: true,
      indexCounter: 0,
      menuList: [
        {
          path: '/dashboard',
          name: 'dashboard',
          icon: 'tachometer-alt',
        },
        //storm
        {
          name: 'storm',
          type: 'sub',
          icon: 'cloud-showers-heavy',
          menuIndex: '1',
          menuList: [
            {
              path: '/storm/summary',
              name: 'summary',
              icon: 'table',
            },
            {
              path: '/storm/data',
              name: 'data',
              icon: 'table',
            },
            {
              path: '/storm/chart',
              name: 'chart',
              icon: 'chart-line',
            },
            {
              path: '/storm/snake-line',
              name: 'snakeLine',
              icon: 'chart-line',
            },
            {
              path: '/storm/export',
              name: 'export',
              icon: 'file-excel',
            },
            {
              path: '/storm/raingrid-iii',
              name: 'storm-raingrid-iii',
              icon: 'cloud-rain',
            },
            {
              path: '/storm/raingrid-ntu',
              name: 'storm-raingrid-ntu',
              icon: 'cloud-rain',
            },
            //{
            //  path: '/storm/raingrid',
            //  name: 'raingrid',
            //  icon: 'table',
            //},
            /*{
              name: 'Admin',
              type: 'sub',
              icon: 'cloud-showers-heavy',
              menuList: [
                {
                  type: 'labelList',
                  label: '設定',
                  menuList: [
                    {
                      path: '/storm/admin/instrument',
                      name: '儀器',
                      icon: 'table',
                    },
                    {
                      path: '/storm/admin/instrument-group',
                      name: '儀器組',
                      icon: 'table',
                    },
                    {
                      path: '/storm/admin/instrumentComputer',
                      name: '儀器公式',
                      icon: 'table',
                    },
                    {
                      path: '/storm/admin/project',
                      name: '專案',
                      icon: 'tasks',
                    },
                    {
                      path: '/storm/admin/area',
                      name: '區域',
                      icon: 'tasks',
                    },
                    {
                      path: '/storm/admin/station',
                      name: '測站',
                      icon: 'tasks',
                    },
                    {
                      path: '/storm/admin/client',
                      name: '客戶',
                      icon: 'tasks',
                    },
                    {
                      path: '/storm/admin/layout',
                      name: '燈號',
                      icon: 'table',
                    },
                    {
                      path: '/storm/admin/remark',
                      name: '備註',
                      icon: 'table',
                    },
                    {
                      path: '/storm/admin/document',
                      name: '檔案',
                      icon: 'table',
                    },
                    {
                      path: '/storm/admin/sms',
                      name: '簡訊',
                      icon: 'sms',
                    },
                    {
                      path: '/storm/admin/log',
                      name: '登入記錄',
                      icon: 'user',
                    },
                  ],
                },
                {
                  type: 'labelList',
                  label: '數據修改',
                  menuList: [
                    {
                      path: '/storm/admin/edit/output',
                      name: 'Output',
                      icon: 'file-excel',
                    },
                    {
                      path: '/storm/admin/edit/instrument',
                      name: 'Instrument',
                      icon: 'file-excel',
                    },
                  ],
                },
              ],
            },*/
          ],
        },
        //slope
        {
          name: 'slope',
          type: 'sub',
          icon: 'mountain',
          menuIndex: '0',
          menuList: [
            {
              path: '/slope/data',
              name: 'data',
              icon: 'table',
            },
            {
              path: '/slope/chart',
              name: 'chart',
              icon: 'chart-line',
            },
            {
              path: '/slope/curve',
              name: 'curve',
              icon: 'chart-line',
            },
            {
              path: '/slope/map',
              name: 'map',
              icon: 'map-marked-alt',
            },
            {
              path: '/slope/layout',
              name: 'layout',
              icon: 'info-circle',
            },
            {
              path: '/slope/export',
              name: 'export',
              icon: 'file-excel',
            },
          ],
        },
        {
          path: '/summary',
          name: 'summary',
          icon: 'table',
        },
        {
          path: '/data',
          name: 'data',
          icon: 'table',
        },
        {
          path: '/chart',
          name: 'chart',
          icon: 'chart-line',
        },
        {
          path: '/snake-line',
          name: 'snakeLine',
          icon: 'chart-line',
        },
        {
          path: '/curve',
          name: 'curve',
          icon: 'chart-line',
        },
        {
          name: 'manual',
          type: 'sub',
          icon: 'pen-square',
          menuIndex: '2',
          menuList: [
            {
              path: '/manual/instrument',
              name: 'manual-instrument',
              icon: 'pen-square',
            },
            {
              path: '/manual/edit',
              name: 'manual-edit',
              icon: 'pen-square',
            },
            {
              path: '/manual/import',
              name: 'manual-import',
              icon: 'file-excel',
            },
            {
              path: '/manual/data',
              name: 'manual-data',
              icon: 'pen-square',
            },
            {
              path: '/manual/frequencyCheck',
              name: 'manual-frequency-check',
              icon: 'pen-square',
            },
            {
              path: '/manual/curve',
              name: 'manual-curve',
              icon: 'chart-bar',
            },
          ],
        },
        {
          path: '/map',
          name: 'map',
          icon: 'map-marked-alt',
        },
        {
          path: '/layout',
          name: 'layout',
          icon: 'info-circle',
        },
        {
          path: '/export',
          name: 'export',
          icon: 'file-excel',
        },
        {
          path: '/monitor',
          name: 'monitor',
          icon: 'camera',
        },
        {
          path: '/rank',
          name: 'rank',
          icon: 'chart-bar',
        },
        {
          path: '/typhoon',
          name: 'typhoon',
          icon: 'fire',
        },
        {
          path: '/monthlyReport',
          name: 'monthlyReport',
          icon: 'file-word',
        },
        {
          path: '/viewEarthquakeReport',
          name: 'viewEarthquakeReport',
          icon: 'globe-asia',
        },
        {
          path: '/cctv-event-monitor',
          name: 'cctv-event-monitor',
          icon: 'bell',
        },
        {
          path: '/ai-event',
          name: 'ai-event-list',
          icon: 'bell',
        },
        {
          path: '/trajectory',
          name: 'trajectory',
          icon: 'signature',
        },
        {
          path: '/occ',
          name: 'occ',
          icon: 'tachometer-alt',
        },
        {
          path: '/noise',
          name: 'noise',
          icon: 'info-circle',
        },
        {
          path: '/details',
          name: (kmrtRole) ? 'details-kmrt' :'details',
          icon: 'info-circle',
        },
        {
          path: '/instrumentInfo',
          name: 'instrumentInfo',
          icon: 'info-circle',
        },
        {
          path: '/contact',
          name: 'contact',
          icon: 'envelope',
        },
        {
          path: '/alerts',
          name: 'alerts',
          icon: 'bell',
        },
        {
          path: '/OCC-Contact',
          name: 'OCC-Contact',
          icon: 'envelope',
        },
        {
          path: '/advanced',
          name: 'AdvancedOptions',
          icon: 'user-cog',
        },
        {
          path: '/remark',
          name: 'remark',
          icon: 'table',
        },
      ],

      adminMenuList: [
        {
          label: '設定',
          routes: [
            {
              path: '/admin/instrument',
              name: '儀器',
              icon: 'table',
            },
            {
              path: '/admin/instrument-group',
              name: '儀器組',
              icon: 'table',
            },
            {
              path: '/admin/instrumentType',
              name: '儀器類型',
              icon: 'table',
            },
            //{
            //  path: '/admin/instrumentComputer',
            //  name: '儀器公式',
            //  icon: 'table',
            //},
            {
              path: '/admin/project',
              name: '專案',
              icon: 'tasks',
            },
            {
              path: '/admin/area',
              name: '區域',
              icon: 'tasks',
            },
            {
              path: '/admin/station',
              name: '測站',
              icon: 'tasks',
            },
            {
              path: '/admin/user',
              name: '用戶管理',
              icon: 'tasks',
            },
            {
              path: '/admin/layout',
              name: '燈號',
              icon: 'table',
            },
            {
              path: '/admin/document',
              name: '檔案',
              icon: 'table',
            },
            {
              path: '/admin/sms',
              name: '簡訊',
              icon: 'sms',
            },
            {
              path: '/admin/log',
              name: '登入記錄',
              icon: 'user',
            },
            ...(isThsrMain ? [{
              path: '/admin/health/data-feeds',
              name: 'AI應用服務健康檢查',
              icon: 'heartbeat',
            }] : []),
            //{
            //  path: '/admin/testing',
            //  name: '內部測試1',
            //  icon: 'user',
            //},
            {
              path: '/admin/feature',
              name: '內部測試2',
              icon: 'table',
            },
          ],
        },
        {
          label: '系統參數',
          routes: [
            {
              path: '/admin/edit/output',
              name: 'Output',
              icon: 'file-excel',
            },
            // {
            //   path: '/admin/edit/data',
            //   name: 'Data',
            //   icon: 'cogs'
            // },
            {
              path: '/admin/edit/output-fill',
              name: '內部測試3',
              icon: 'file-excel',
            },
            {
              path: '/admin/edit/instrument',
              name: 'Instrument',
              icon: 'file-excel',
            },
            {
              path: '/admin/edit/alert-group',
              name: 'AlertGroup',
              icon: 'bell',
            },
          ],
        },
      ],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters['user/isAdmin'];
    },
    isProjectManager() {
      return this.$store.getters['user/isProjectManager'];
    },
    showAdminMenu() {
      if (this.isAdmin) return true;
      if (this.isProjectManager) {
        const managedProjects = this.$store.getters['user/managedProjects'];
        return managedProjects.includes(this.selectedProject._id);
      }
      return false;
    },
    filteredAdminMenuList() {
      if (this.isAdmin) return this.adminMenuList;
      // Project Manager 只顯示「系統參數」群組中的 Instrument 和 Output
      return [{
        label: '系統參數',
        routes: [
          {
            path: '/admin/edit/output',
            name: 'Output',
            icon: 'file-excel',
          },
          {
            path: '/admin/edit/output-fill',
            name: 'OutputFill',
            icon: 'file-excel',
          },
          {
            path: '/admin/edit/instrument',
            name: 'Instrument',
            icon: 'file-excel',
          },
        ],
      }];
    },
    enableLayoutPin() {
      return this.$store.getters['project/enableLayoutPin'];
    },
    userRole() {
      return this.$store.getters['user/details'].roles;
    },
    manualImportPath() {
      const projectId = this.selectedProject?._id;
      if (isThsrProject(projectId)) {
        return '/manual/import-thsr';
      }
      if (importRole) {
        return '/manual/import-kmrt';
      }
      return '/manual/import';
    },

    getMenuList() {
      const allowedTab = this.allowedTab;
      if ([null, undefined].includes(allowedTab) || allowedTab.length === 0) {
        console.log('get no allowedTab');
        return this.menuList;
      }

      const projectId = this.selectedProject?._id;

      return this.menuList.map(ele => {
        if (ele.type === 'sub') {
          return {
            ...ele,
            menuList: ele.menuList
              .filter(child => allowedTab.includes(child.name))
              .filter(child => {
                if (child.name === 'manual-curve') return isThsrProject(projectId);
                return true;
              })
              .map(child => {
                // 這裡改用計算好的 manualImportPath
                if (child.name === 'manual-import') {
                  return { ...child, path: this.manualImportPath };
                }
                return child;
              }),
          };
        }
        return ele;
      }).filter(ele => allowedTab.includes(ele.name));
    },
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    allowedTab() {
      return this.selectedProject?.allowed_sidebar;
    },
  },
  mounted() {
    if(this.userRole == 'occ'){
      this.menuList = [
        {
          path: '/occ',
          name: 'occ',
          icon: 'tachometer-alt',
        },
        {
          path: '/chart',
          name: 'chart',
          icon: 'chart-line',
        },
        {
          path: '/alerts',
          name: 'alerts',
          icon: 'bell',
        },
        {
          path: '/OCC-Contact',
          name: 'OCC-Contact',
          icon: 'envelope',
        },
      ];
      //console.log(this.menuList);
    }
    else{
      if(this.userRole !== 'admin' && this.userRole !== 'thsr') {
        this.removeStormFromMenuList();
      }
      if(this.userRole !== 'admin' && this.userRole !== 'nbiot') {
        this.removeAdvancedOptionFromMenuList();
      }
    }
    Object.keys(sidebar).forEach(ele => {
      if (!sidebar[ele]) {
        this.removeFromSidebar(ele);
      }
    });
    console.log(this.menuList);
  },
  methods: {
    removeFromSidebar(key) {
      const itemIndex = this.menuList.findIndex(ele => ele.name === key);
      if (itemIndex !== -1 && this.userRole !== 'occ'){
        this.menuList.splice(itemIndex, 1);
      }
    },
    removeStormFromMenuList() {
      const stormIndex = this.menuList.findIndex(item => item.name === 'storm');
      if (stormIndex !== -1) {
        this.menuList.splice(stormIndex, 1);
      }
    },
    removeAdvancedOptionFromMenuList() {
      const aOIndex = this.menuList.findIndex(item => item.name === 'AdvancedOptions');
      if (aOIndex !== -1) {
        this.menuList.splice(aOIndex, 1);
      }
    },
    collapse(){
      this.$emit('collapse',this.isCollapse);
    },
  },
};
</script>

<style lang="stylus" scoped>
// 針對 el-menu 的基礎設定
.sidebar-menu
  height 100%
  min-height calc(100vh - 60px)
  background white
  overflow-x hidden
  border-right none
  
  // 展開時的寬度與樣式
  &:not(.el-menu--collapse)
    width 200px
    .sidebar-collapse-switch
      padding 10px 0 10px 10px // 左側留白
      text-align left

  // 縮合時的寬度與樣式
  &.el-menu--collapse
    // width 64px // el-menu--collapse 會自動處理寬度，通常不需強制寫死，但寫了保險
    .sidebar-collapse-switch
      padding 10px 0
      text-align center
      .el-switch
        margin-left 0
    
    // 強制修正縮合時 Icon 的位置
    /deep/ .el-tooltip, /deep/ .el-submenu__title
      padding 0 !important
      text-align center
      
    .icon-container
      display inline-block
      width 100%
      text-align center

// 通用樣式
.route-name
  margin-left 10px // 縮小間距，原本 1rem 有點大

.el-menu-item.is-active
  border-left 4px solid #409EFF
  background-color #ecf5ff

.group-name
  font-size 14px
  padding-left 20px
  color #909399
  
.icon-container
  display inline-block
  width 24px
  text-align center
</style>
